// extracted by mini-css-extract-plugin
export default {"customColorText":"PhoneMasking_customColorText__miryw","customColorTextWithTooltip":"PhoneMasking_customColorTextWithTooltip__A8XGJ"};